import { PageShell } from "~/components/layout/page-shell";
import { Skeleton } from "~/components/ui/skeleton";
import { cn } from "~/lib/utils";

/**
 * Router pending state for /stocks (pendingMs: 0): the app chrome stays live
 * while this paints the page's silhouette inside the outlet during the lazy
 * chunk load. Mirrors the real page's first frame so the fill-in lands in
 * the same geometry.
 *
 * Ships in the EAGER route file, not the lazy page chunk — keep imports to
 * layout primitives only.
 */
export function StocksPagePending() {
  return (
    <PageShell
      className="bg-surface-1 pb-10"
      contentClassName="pt-2"
      padY="none"
      size="wide"
    >
      <PageShell.Hero>
        <div className="relative mb-6">
          <div className="flex min-h-[clamp(11rem,26vh,14rem)] flex-col justify-center bg-surface-2 px-[max(1rem,calc((100vw-96rem)/2+1rem))] py-8 dark:bg-[#020202]">
            <Skeleton className="h-10 w-full max-w-96 rounded-full" />
            <Skeleton className="mt-4 h-3.5 w-full max-w-[29rem] rounded-full" />
            <Skeleton className="mt-2 h-3.5 w-full max-w-80 rounded-full" />
          </div>
          <div className="grid grid-cols-2 items-center gap-3 border-y bg-card px-[max(1rem,calc((100vw-96rem)/2+1rem))] py-4 md:grid-cols-4">
            {Array.from({ length: 4 }, (_, index) => (
              <Skeleton
                className={cn(
                  "h-12 rounded-xl border",
                  index > 1 && "hidden md:block",
                )}
                key={index}
              />
            ))}
          </div>
        </div>
      </PageShell.Hero>
      <PageShell.Main>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton
              className={cn(
                "h-[8.5rem] rounded-2xl border bg-card",
                index > 1 && "hidden md:block",
              )}
              key={index}
            />
          ))}
        </div>
      </PageShell.Main>
    </PageShell>
  );
}
